import { render, staticRenderFns } from "./SorteoNumerosTodos.vue?vue&type=template&id=070a76c4&"
import script from "./SorteoNumerosTodos.vue?vue&type=script&lang=ts&"
export * from "./SorteoNumerosTodos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports